import { IFee } from '@/pages/Tools/BuildingInspection/Models';

import { randomDateWithin } from './dummy_helper';

export const allFees: IFee[] = [
  {
    _id: 'fee-001-1-a',
    inspection_id: 'ins-001-1',
    fee: 120,
    paymentMethod: 'Check',
    checkNumber: 'CHK-001-1-A',
    receiptNumber: 'RCPT-001-1-A',
    feeExplanation: 'Fee for inspection',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-001-1-b',
    inspection_id: 'ins-001-1',
    fee: 95,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-001-1-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-001-2-a',
    inspection_id: 'ins-001-2',
    fee: 200,
    paymentMethod: 'Check',
    checkNumber: 'CHK-001-2-A',
    receiptNumber: 'RCPT-001-2-A',
    feeExplanation: 'Re-inspection fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-001-2-b',
    inspection_id: 'ins-001-2',
    fee: 75,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-001-2-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-001-3-a',
    inspection_id: 'ins-001-3',
    fee: 160,
    paymentMethod: 'Check',
    checkNumber: 'CHK-001-3-A',
    receiptNumber: 'RCPT-001-3-A',
    feeExplanation: 'Completion fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-001-3-b',
    inspection_id: 'ins-001-3',
    fee: 90,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-001-3-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-002-1-a',
    inspection_id: 'ins-002-1',
    fee: 120,
    paymentMethod: 'Check',
    checkNumber: 'CHK-002-1-A',
    receiptNumber: 'RCPT-002-1-A',
    feeExplanation: 'Fee for inspection',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-002-1-b',
    inspection_id: 'ins-002-1',
    fee: 95,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-002-1-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-002-2-a',
    inspection_id: 'ins-002-2',
    fee: 200,
    paymentMethod: 'Check',
    checkNumber: 'CHK-002-2-A',
    receiptNumber: 'RCPT-002-2-A',
    feeExplanation: 'Re-inspection fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-002-2-b',
    inspection_id: 'ins-002-2',
    fee: 75,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-002-2-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-002-3-a',
    inspection_id: 'ins-002-3',
    fee: 160,
    paymentMethod: 'Check',
    checkNumber: 'CHK-002-3-A',
    receiptNumber: 'RCPT-002-3-A',
    feeExplanation: 'Completion fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-002-3-b',
    inspection_id: 'ins-002-3',
    fee: 90,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-002-3-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-003-1-a',
    inspection_id: 'ins-003-1',
    fee: 120,
    paymentMethod: 'Check',
    checkNumber: 'CHK-003-1-A',
    receiptNumber: 'RCPT-003-1-A',
    feeExplanation: 'Fee for inspection',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-003-1-b',
    inspection_id: 'ins-003-1',
    fee: 95,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-003-1-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-003-2-a',
    inspection_id: 'ins-003-2',
    fee: 200,
    paymentMethod: 'Check',
    checkNumber: 'CHK-003-2-A',
    receiptNumber: 'RCPT-003-2-A',
    feeExplanation: 'Re-inspection fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-003-2-b',
    inspection_id: 'ins-003-2',
    fee: 75,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-003-2-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-003-3-a',
    inspection_id: 'ins-003-3',
    fee: 160,
    paymentMethod: 'Check',
    checkNumber: 'CHK-003-3-A',
    receiptNumber: 'RCPT-003-3-A',
    feeExplanation: 'Completion fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-003-3-b',
    inspection_id: 'ins-003-3',
    fee: 90,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-003-3-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-004-1-a',
    inspection_id: 'ins-004-1',
    fee: 120,
    paymentMethod: 'Check',
    checkNumber: 'CHK-004-1-A',
    receiptNumber: 'RCPT-004-1-A',
    feeExplanation: 'Fee for inspection',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-004-1-b',
    inspection_id: 'ins-004-1',
    fee: 95,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-004-1-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-004-2-a',
    inspection_id: 'ins-004-2',
    fee: 200,
    paymentMethod: 'Check',
    checkNumber: 'CHK-004-2-A',
    receiptNumber: 'RCPT-004-2-A',
    feeExplanation: 'Re-inspection fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-004-2-b',
    inspection_id: 'ins-004-2',
    fee: 75,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-004-2-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-004-3-a',
    inspection_id: 'ins-004-3',
    fee: 160,
    paymentMethod: 'Check',
    checkNumber: 'CHK-004-3-A',
    receiptNumber: 'RCPT-004-3-A',
    feeExplanation: 'Completion fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-004-3-b',
    inspection_id: 'ins-004-3',
    fee: 90,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-004-3-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-005-1-a',
    inspection_id: 'ins-005-1',
    fee: 120,
    paymentMethod: 'Check',
    checkNumber: 'CHK-005-1-A',
    receiptNumber: 'RCPT-005-1-A',
    feeExplanation: 'Fee for inspection',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-005-1-b',
    inspection_id: 'ins-005-1',
    fee: 95,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-005-1-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-005-2-a',
    inspection_id: 'ins-005-2',
    fee: 200,
    paymentMethod: 'Check',
    checkNumber: 'CHK-005-2-A',
    receiptNumber: 'RCPT-005-2-A',
    feeExplanation: 'Re-inspection fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-005-2-b',
    inspection_id: 'ins-005-2',
    fee: 75,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-005-2-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-005-3-a',
    inspection_id: 'ins-005-3',
    fee: 160,
    paymentMethod: 'Check',
    checkNumber: 'CHK-005-3-A',
    receiptNumber: 'RCPT-005-3-A',
    feeExplanation: 'Completion fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-005-3-b',
    inspection_id: 'ins-005-3',
    fee: 90,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-005-3-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-006-1-a',
    inspection_id: 'ins-006-1',
    fee: 120,
    paymentMethod: 'Check',
    checkNumber: 'CHK-006-1-A',
    receiptNumber: 'RCPT-006-1-A',
    feeExplanation: 'Fee for inspection',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-006-1-b',
    inspection_id: 'ins-006-1',
    fee: 95,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-006-1-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-006-2-a',
    inspection_id: 'ins-006-2',
    fee: 200,
    paymentMethod: 'Check',
    checkNumber: 'CHK-006-2-A',
    receiptNumber: 'RCPT-006-2-A',
    feeExplanation: 'Re-inspection fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-006-2-b',
    inspection_id: 'ins-006-2',
    fee: 75,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-006-2-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-006-3-a',
    inspection_id: 'ins-006-3',
    fee: 160,
    paymentMethod: 'Check',
    checkNumber: 'CHK-006-3-A',
    receiptNumber: 'RCPT-006-3-A',
    feeExplanation: 'Completion fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-006-3-b',
    inspection_id: 'ins-006-3',
    fee: 90,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-006-3-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-007-1-a',
    inspection_id: 'ins-007-1',
    fee: 120,
    paymentMethod: 'Check',
    checkNumber: 'CHK-007-1-A',
    receiptNumber: 'RCPT-007-1-A',
    feeExplanation: 'Fee for inspection',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-007-1-b',
    inspection_id: 'ins-007-1',
    fee: 95,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-007-1-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-007-2-a',
    inspection_id: 'ins-007-2',
    fee: 200,
    paymentMethod: 'Check',
    checkNumber: 'CHK-007-2-A',
    receiptNumber: 'RCPT-007-2-A',
    feeExplanation: 'Re-inspection fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-007-2-b',
    inspection_id: 'ins-007-2',
    fee: 75,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-007-2-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-007-3-a',
    inspection_id: 'ins-007-3',
    fee: 160,
    paymentMethod: 'Check',
    checkNumber: 'CHK-007-3-A',
    receiptNumber: 'RCPT-007-3-A',
    feeExplanation: 'Completion fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-007-3-b',
    inspection_id: 'ins-007-3',
    fee: 90,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-007-3-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-008-1-a',
    inspection_id: 'ins-008-1',
    fee: 120,
    paymentMethod: 'Check',
    checkNumber: 'CHK-008-1-A',
    receiptNumber: 'RCPT-008-1-A',
    feeExplanation: 'Fee for inspection',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-008-1-b',
    inspection_id: 'ins-008-1',
    fee: 95,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-008-1-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-008-2-a',
    inspection_id: 'ins-008-2',
    fee: 200,
    paymentMethod: 'Check',
    checkNumber: 'CHK-008-2-A',
    receiptNumber: 'RCPT-008-2-A',
    feeExplanation: 'Re-inspection fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-008-2-b',
    inspection_id: 'ins-008-2',
    fee: 75,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-008-2-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-008-3-a',
    inspection_id: 'ins-008-3',
    fee: 160,
    paymentMethod: 'Check',
    checkNumber: 'CHK-008-3-A',
    receiptNumber: 'RCPT-008-3-A',
    feeExplanation: 'Completion fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-008-3-b',
    inspection_id: 'ins-008-3',
    fee: 90,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-008-3-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-009-1-a',
    inspection_id: 'ins-009-1',
    fee: 120,
    paymentMethod: 'Check',
    checkNumber: 'CHK-009-1-A',
    receiptNumber: 'RCPT-009-1-A',
    feeExplanation: 'Fee for inspection',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-009-1-b',
    inspection_id: 'ins-009-1',
    fee: 95,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-009-1-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-009-2-a',
    inspection_id: 'ins-009-2',
    fee: 200,
    paymentMethod: 'Check',
    checkNumber: 'CHK-009-2-A',
    receiptNumber: 'RCPT-009-2-A',
    feeExplanation: 'Re-inspection fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-009-2-b',
    inspection_id: 'ins-009-2',
    fee: 75,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-009-2-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-009-3-a',
    inspection_id: 'ins-009-3',
    fee: 160,
    paymentMethod: 'Check',
    checkNumber: 'CHK-009-3-A',
    receiptNumber: 'RCPT-009-3-A',
    feeExplanation: 'Completion fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-009-3-b',
    inspection_id: 'ins-009-3',
    fee: 90,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-009-3-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-010-1-a',
    inspection_id: 'ins-010-1',
    fee: 120,
    paymentMethod: 'Check',
    checkNumber: 'CHK-010-1-A',
    receiptNumber: 'RCPT-010-1-A',
    feeExplanation: 'Fee for inspection',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-010-1-b',
    inspection_id: 'ins-010-1',
    fee: 95,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-010-1-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-010-2-a',
    inspection_id: 'ins-010-2',
    fee: 200,
    paymentMethod: 'Check',
    checkNumber: 'CHK-010-2-A',
    receiptNumber: 'RCPT-010-2-A',
    feeExplanation: 'Re-inspection fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-010-2-b',
    inspection_id: 'ins-010-2',
    fee: 75,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-010-2-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },

  {
    _id: 'fee-010-3-a',
    inspection_id: 'ins-010-3',
    fee: 160,
    paymentMethod: 'Check',
    checkNumber: 'CHK-010-3-A',
    receiptNumber: 'RCPT-010-3-A',
    feeExplanation: 'Completion fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
  {
    _id: 'fee-010-3-b',
    inspection_id: 'ins-010-3',
    fee: 90,
    paymentMethod: 'Certified Payments',
    receiptNumber: 'RCPT-010-3-B',
    feeExplanation: 'Processing fee',
    datePayed: randomDateWithin(190),
    note: '',
  },
];
